import React from 'react'
import { Heading, Stack } from '@chakra-ui/react'

export const LatestAlbumsAll = () => {
  console.log( "YAO ALBUMS ALL" )
  return (
    <Stack mt={4}>
      <Heading>LATEST ALBUMS ALL</Heading>
    </Stack>
  )
}
